/**
 * Hospitalisations Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";
import AppConfig from "../../../constants/AppConfig";

// States
const state = {
    hospitalisations: [],
    hospitalisation: {}
};

// Getters
const getters = {
    hospitalisations: state => {
        return state.hospitalisations
    },

    hospitalisation: state => {
        return state.hospitalisation
    }
};

// Actions
const actions = {
    printHospitalisation(context, payload) {
        function successCallback(response) {
            let url= AppConfig.imgUrl+'/public/storage/pdf/'+response.data.name;
            let fileName = response.data.name;

            Vue.axios.get(
                url,{
                    responseType: 'blob', // important
                }
            ).then((response) => {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        }


        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Hospitalisation.Print, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getHospitalisations(context, payload) {
        function successCallback(response) {
            context.commit('getHospitalisationsHandler', { hospitalisations: response.data.hospitalisations });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Hospitalisation.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getHospitalisation(context, payload) {
        function successCallback(response) {
            context.commit('getHospitalisationHandler', { hospitalisation: response.data.hospitalisation });
            context.commit('getMedicalFileHandler', { file: response.data.hospitalisation.dossier });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Hospitalisation.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createHospitalisation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

           router.push({ name: 'hospitalisation', params: { hospitalisation: response.data.hospitalisation.slug } });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Hospitalisation.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateHospitalisation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            // router.push({ name: 'hospitalisation', params: { hospitalisation: response.data.hospitalisation.slug } });
            store.dispatch('findAndRemove', {name: 'hospitalisation' });
            router.push({ name: 'hospitalisation', params: { hospitalisation: response.data.hospitalisation.slug } });

            // router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.hospitalisation.dossier.slug } }).href) +"#Hospitalisation");
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Hospitalisation.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteHospitalisation(context, payload) {
        function successCallback(response) {
            context.commit('deleteHospitalisationHandler', { index: payload.index, successMessage: payload.successMessage });
            router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.hospitalisation.dossier.slug } }).href) +"#Hospitalisation");

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Hospitalisation.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createHospitalisationPhysicalExams(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'hospitalisation.physical-exams' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Hospitalisation.PhysicalExam.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteHospitalisationPhysicalExam(context, payload) {
        function successCallback(response) {
            context.commit('deleteHospitalisationPhysicalExamHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Hospitalisation.PhysicalExam.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createHospitalisationComplementaryExams(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'hospitalisation.complementary-exams' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Hospitalisation.ComplementaryExam.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    // deleteHospitalisationComplementaryExam(context, payload) {
    //     function successCallback(response) {
    //         context.commit('deleteHospitalisationComplementaryExamHandler', { index: payload.index, successMessage: payload.successMessage });
    //         router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.hospitalisation.dossier.slug } }).href) +"#Hospitalisation");
    //     }
    //
    //     function errorCallback(error) {
    //         Vue.swal(
    //             payload.errorMessages.error,
    //             '',
    //             'error'
    //         );
    //     }
    //
    //     const localToken = localStorage.getItem('ms-token');
    //
    //     makeApiRequest(payload.args, apiModel.Hospitalisation.ComplementaryExam.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    // },

    archieveHospitalisation(context, payload) {
        function successCallback(response) {
            context.commit('archieveHospitalisationHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getHospitalisationHandler', { hospitalisation: response.data.resultat });
            router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.resultat.dossier.slug } }).href) +"#Hospitalisation");

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Hospitalisation.Archieve, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    transmitHospitalisation(context, payload) {
        function successCallback(response) {
            context.commit('transmitHospitalisationHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getHospitalisationHandler', { hospitalisation: response.data.resultat });
            router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.resultat.dossier.slug } }).href) +"#Hospitalisation");

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Hospitalisation.Transmit, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getHospitalisationsHandler(state, { hospitalisations }) {
        // Update hospitalisations state
        state.hospitalisations = hospitalisations;
    },

    getHospitalisationHandler(state, { hospitalisation }) {
        // Update hospitalisation state
        state.hospitalisation = hospitalisation;
    },

    deleteHospitalisationHandler(state, { index, successMessage }) {
        // let i = state.hospitalisations.findIndex(hospitalisation => hospitalisation.slug === index);
        //
        // if (~i) {
        //     state.hospitalisations.splice(i, 1);

            // router.push({ name: 'hospitalisations' });

            // router.resolve()
            Vue.swal(
                successMessage,
                '',
                'success'
            );
        // }
    },

    // deleteHospitalisationPhysicalExamHandler(state, { index, successMessage }) {
    //     let i = state.physicalExams.findIndex(physicalExam => physicalExam.slug === index);
    //
    //     if (~i) {
    //         state.physicalExams.splice(i, 1);
    //
    //         router.push({ name: 'hospitalisation.physical-exams' });
    //
    //         Vue.swal(
    //             successMessage,
    //             '',
    //             'success'
    //         );
    //     }
    // },
    //
    // deleteHospitalisationComplementaryExamHandler(state, { index, successMessage }) {
    //     let i = state.complementaryExams.findIndex(complementaryExam => complementaryExam.slug === index);
    //
    //     if (~i) {
    //         state.complementaryExams.splice(i, 1);
    //
    //         router.push({ name: 'hospitalisation.complementary-exams' });
    //
    //         Vue.swal(
    //             successMessage,
    //             '',
    //             'success'
    //         );
    //     }
    // },

    archieveHospitalisationHandler(state, { index, successMessage }) {
        // router.push({ name: 'hospitalisations' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    transmitHospitalisationHandler(state, { index, successMessage }) {
        // router.push({ name: 'hospitalisations' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}